
            const data = {"name":"remove","data":{"width":"20","height":"20","viewBox":"0 0 20 20","data":"<circle pid=\"0\" opacity=\".1\" cx=\"10\" cy=\"10\" r=\"10\" _fill=\"#F82626\"/><path pid=\"1\" _stroke=\"#F82626\" stroke-width=\"1.053\" d=\"M6.842 10h6.842\"/>","originalColors":[{"type":"fill","color":"#F82626"},{"type":"stroke","color":"#F82626"}],"stopColors":[]}}
        
                    module.exports = data
                    